import colors from 'vuetify/lib/util/colors';
import { environment } from '../../environment/environment';
export var appearance = {
  methods: {

    environmentPriorityObject(generalExApplicationEx, transactionEx) {
      const general = generalExApplicationEx?.generalEx?.general;
      const application = generalExApplicationEx?.applicationEx?.application;
      const transaction = transactionEx?.transaction;
      return transaction ? transaction : application ? application : general;
    },

    environmentPriority(tag, generalExApplicationEx, transactionEx) {
      const general = generalExApplicationEx?.generalEx?.general ?? {};
      const application = generalExApplicationEx?.applicationEx?.application ?? {};
      const transaction = transactionEx?.transaction ?? {};
      return transaction[tag] ? transaction[tag] : application[tag] ? application[tag] : general[tag];
    },


    frameWorkName(generalExApplicationEx) {
      return generalExApplicationEx?.generalEx?.general?.frameWorkName ?? 'Loading ...';
    },

    applicationTitle(generalExApplicationEx, language) {
      const object = this.environmentPriorityObject(generalExApplicationEx);
      const title = object ? this.translatedConfig(generalExApplicationEx, language, object, 'title') : null;
      const prefix = environment?.endpoint?.prefix ? '(' + environment.endpoint.name.toUpperCase() + ') ' : '';
      return prefix  + (title ?? "");
    },

    primaryColor(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.priColor ?? "transparent";
    },
    secondaryColor(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.secColor ?? "transparent";
    },
    tertiaryColor(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.terColor ?? "transparent";
    },
    notificationColor(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.notificationColor;
    },
    notificationMode(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.notificationMode ?? "alertCentered";
    },
    notificationAlertCentered(generalExApplicationEx) {
      return this.notificationMode(generalExApplicationEx) == 'alertCentered'
    },
    notificationLayoutBottom(generalExApplicationEx) {
      return this.notificationMode(generalExApplicationEx) == 'layoutBottom'
    },
    fullLogo(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.urlLogo ?? "favicon.png";
    },
    fullIcon(generalExApplicationEx) {
      return generalExApplicationEx?.theme?.urlIco ?? "favicon.ico";
    },
    messageMode(generalExApplicationEx, transactionEx) {
      const messageMode = this.environmentPriority('messageMode', generalExApplicationEx, transactionEx);
      return messageMode ? messageMode : 'simple';
    },
    screenSize() {
      const width = window.innerWidth;
      return width < 600
        ? 'xs'
        : width >= 600 && width < 960
          ? 'sm'
          : width >= 960 && width < 1264
            ? 'md'
            : width >= 1264 && width < 1904
              ? 'lg'
              : 'xl';
    },

    betterMaxfields() {
      const size = this.screenSize();
      return size == 'xs' ? 1 : size == 'sm' ? 2 : size == 'md' ? 4 : null;
    },

    adjustMaxFields(maxFields) {
      const better = this.betterMaxfields();
      return better && better < maxFields ? better : maxFields;
    },

    smallQuery(screen) {
      const size = this.screenSize();
      const small = screen.transaction.queryDisplay == 'small';
      return small ? true : size == 'xs' ? true : size == 'sm' ? true : false;
    },
    regularQuery(screen) {
      return !this.smallQuery(screen);
    },

    embedWidth() {
      const size = this.screenSize();
      return size == 'xs' ? 'unset' : null;
    },

    hexaColor(color) {
      if ('string' !== typeof color || color.trim().length == 0) {
        return color;
      }
      if (color.startsWith('#') || color.startsWith('rgb')) {
        return color;
      }
      const themeColors = Object.keys(this.$vuetify.theme.currentTheme);
      const themeColorIndex = themeColors.indexOf(color);
      if (themeColorIndex > -1) {
        return this.$vuetify.theme.currentTheme[color];
      }
      let baseColor;
      let shade;
      if (color.includes(' ')) {
        const [bc, s] = color.split(' ');
        baseColor = bc;
        shade = s;
      }
      else {
        baseColor = color;
        shade = 'base';
      }
      const generalColors = Object.keys(colors);
      const generalColorsIndex = generalColors.indexOf(baseColor);
      const themeColorsShadeIndex = themeColors.indexOf(baseColor);
      if (generalColorsIndex > -1) {
        const fixedShade = shade.toLowerCase().replace('-', '');
        const co = colors[generalColors[generalColorsIndex]];
        return co[fixedShade];
      }
      else if (themeColorsShadeIndex > -1) {
        const fixedShade = shade.toLowerCase().replace('-', '');
        const co = this.$vuetify.theme.parsedTheme[themeColors[themeColorsShadeIndex]]
        return co[fixedShade];
      }
      return color;
    },


    errorColor() {
      return "#FF5252"
    },
    successColor() {
      return "#4CAF50"
    },
    warningColor() {
      return "#FFC107"
    },
    infoColor() {
      return "#2196F3"
    },

    allCustomStyle(input) {
      const queryFlagStyle = "font-size: 0.9em; ";
      return input.customStyle
        ? input.queryFlag
          ? queryFlagStyle + input.customStyle
          : input.customStyle
        : input.queryFlag
          ? queryFlagStyle
          : null;
    },

    dynamicClass(input) {
      const customName = 'custom-' + input.type + '-style';
      const queryFlagName = 'query-flag';
      let result = {};
      result[customName] = input.customStyle ? true : false;
      result[queryFlagName] = input.queryFlag ? true : false;
      return result;
    },

    dynamicStyle(input) {
      let formatted = null;

      if (input.customStyle) {
        eval('formatted = ' + input.customStyle);
        ["label", "input", "prefix", "slot", "field"].forEach((category) => {
          [
            "color",
            "background-color",
            "size",
            "border",
            "border-radius",
          ].forEach((property) => {
            const tag = category + "-" + property;
            formatted['--' + tag] = formatted[tag]
              ? formatted[tag]
              : "initial";
          });
        });
      }

      return formatted;
    },

    querySpreadColor(screen, record) {
      const queryFields = screen.queryFieldsEx;
      const spreadColors = queryFields.map((qfe) => {
        const value = record[qfe.queryField.fieldName];
        const dictionaryName = qfe.queryField.dictionaryName;
        const dictionary = this.findDictionary(screen, dictionaryName);
        return this.spreadColorCatalogItem(
          dictionary,
          value,
          this.findCatalogExList(screen, dictionaryName, null)
        );
      });
      const isThereSpreadColor = spreadColors.some((sc) => {
        return sc != null;
      });
      if (isThereSpreadColor) {
        const result = spreadColors.find((sc) => {
          return sc != null;
        });
        return result;
      } else {
        return null;
      }
    },

    queryIconColor(screen, record) {
      const queryFields = screen.queryFieldsEx;
      const iconColors = queryFields.map((qfe) => {
        const value = record[qfe.queryField.fieldName];
        const dictionaryName = qfe.queryField.dictionaryName;
        const dictionary = this.findDictionary(screen, dictionaryName);
        return this.iconColorCatalogItem(
          dictionary,
          value,
          this.findCatalogExList(screen, dictionaryName, null)
        );
      });
      const isThereIconColor = iconColors.some((sc) => {
        return sc != null;
      });
      if (isThereIconColor) {
        const result = iconColors.find((sc) => {
          return sc != null;
        });
        return result;
      } else {
        return null;
      }
    },
  }
}